import React, { useEffect, useState } from "react";
import { Table, Button, Form, Modal, Spinner } from "react-bootstrap";
import useReactRouter from "use-react-router";
import * as _ from "lodash";
import { useInitFbSDK } from "../../helpers/fb-hooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Cookies from 'js-cookie';
import {
  faDatabase,
  faEdit,
  faEye,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { COLOR_APP, COLOR_APP_CANCEL, CREATED } from "../../constants";
import {
  successSwal,
  errorSwal,
  errorTitleWithTextSwal,
} from "../../helpers/sweetalert";


import { faPlus } from "@fortawesome/free-solid-svg-icons";
import shoppingAnimation from "../../image/sopping.json";
import Lottie from "lottie-react";
import Group from "../../image/Group.png";
import moment from "moment";
import Swal from "sweetalert2";
import { useToasts } from "react-toast-notifications";
import AnimationLoading from "../../components/AnimationLoading";
import reactUsestateref from "react-usestateref";
import EmptyComponent from "../../components/EmptyComponent";
import "./postScreen/postScreen.css";
import { useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { GET_LIVE_STOCKS } from "../../graphql/liveStock/query";
import { UPDATE_STOCK } from "../../graphql/stock/mutation";
import { SHOP } from "../../graphql/shop/queryShop";
import { convertLiveStatus } from "../../helpers/liveStatus";
import { GET_POSTS } from "../../graphql/post/query";
import {
  DELETE_POST,
  START_HOOK_POST,
  STOP_HOOK_POST,
  UPDATE_POST,
} from "../../graphql/post/mutation";
import Switch from "react-switch";
import { connect } from "react-redux";
import BasicModal from "../../components/BasicModal";
import { GET_POST_STOCKS } from "../../graphql/postStock/query";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import LoadingSpinner from "../../components/LoadingSpinner";
import PackageNotPermission from "../../components/currentComponent/PackageNotPermission";
import { GET_SETTING_BY_SHOP } from "../../graphql/setting/query";

function PostFeed({ }) {
  const { height, width } = useWindowDimensions();
  const shopPageCookie = Cookies.get('SHOP_PAGE');
  const assignedPageList = shopPageCookie ? JSON.parse(shopPageCookie) : [];

  // const assignedPageList = JSON.parse(localStorage.getItem('SHOP_PAGE'));

  const { addToast } = useToasts();
  const { history } = useReactRouter();
  const isFbSDKInitialized = useInitFbSDK();

  const LIMIT_PAGE = 30;
  // const navigate = useNavigate();

  // App state
  const [fbUserAccessToken, setFbUserAccessToken] = useState();
  // const [assignedPageList, setAssignedPageList] = useState([]);
  const [liveList, setLiveList] = useState([]);
  const [liveTotal, setLiveTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showGuide, setShowGuide] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteData, setDeleteData] = useState();
  const [currentStatus, setCurrentStatus] = useState("ALL");
  const [showDeletePostSuccess, setShowDeletePostSuccess] = useState(false);

  //ERROR CHECK
  const [selectedLive, setSelectedLive] = useState();
  const [isContinue, setIsContinue] = useState(false);

  //modal
  const [showDeletePostConfirm, setShowDeletePostConfirm] = useState(false);
  const [showOptionModal, setShowOptionModal] = useState(false);

  //Pagination
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCountNumber, setPageCountNumber] = useState(1);
  let shopIdIn = localStorage.getItem("SHOP");
  const [isModalLess, setIsModalLess] = useState(false)

  const [getPostData, { data: postsData }] = useLazyQuery(GET_POSTS, {
    fetchPolicy: "cache-and-network",
  });
  const [getPostShopStockForValidate, { data: postShopStockDataForValidate }] =
    useLazyQuery(GET_LIVE_STOCKS, { fetchPolicy: "cache-and-network" });
  const [getShop, { data: shopValidatedData }] = useLazyQuery(SHOP, {
    fetchPolicy: "cache-and-network",
  });
  const [getPostStocks, { data: postStockData }] = useLazyQuery(
    GET_POST_STOCKS,
    { fetchPolicy: "cache-and-network" }
  );

   // setting by shop
   const { data: settingData } = useQuery(GET_SETTING_BY_SHOP, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        shop: shopIdIn,
      },
    },
  });


  const [deletePost] = useMutation(DELETE_POST);
  const [updateStock] = useMutation(UPDATE_STOCK);
  const [updatePost] = useMutation(UPDATE_POST);
  const [startHookPost] = useMutation(START_HOOK_POST);
  const [stopHookPost] = useMutation(STOP_HOOK_POST);

  // Checks if the user is logged in to Facebook
  React.useEffect(() => {
    if (isFbSDKInitialized) {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse?.accessToken);
        else
          errorTitleWithTextSwal(
            "ມີຂໍ້ຜິດພາດ",
            "ໃນການເຂົ້າສູ່ລະບົບດ້ວຍເຟສບຸກ ລອງໃຫມ່ອີກຄັ້ງ"
          );
      });
    }
    getPost();
  }, [isFbSDKInitialized]);

  useEffect(() => {
    if (shopValidatedData) {
      //Check error point
      // console.log(shopValidatedData?.shop?.paymentType);
      if (shopValidatedData?.shop?.paymentType == "POINT") {
        if (shopValidatedData?.shop?.point <= 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ຄະແນນຂອງທ່ານບໍ່ພຽງພໍ!",
            html:
              `<div className="text-left">ກະລຸນາເຕີ່ມຄະແນນກ່ອນ ຈຶ່ງສາມາດເລີ່ມຕໍ່ການ Live ໄດ້ <br/>` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      //Check If Subscription period
      if (shopValidatedData?.shop?.paymentType == "SUBSCRIPTION") {
        if (moment().diff(shopValidatedData?.shop?.endDate, "days") > 0) {
          setIsLoading(false);
          Swal.fire({
            icon: "error",
            title: "ໄລຍະເວລາການໃຊ້ງານຂອງທ່ານສິ້ນສຸດແລ້ວ!",
            html:
              `<div className="text-left">` +
              "ຕິດຕໍ່ຫາພວກເຮົາ ເພື່ອເຕີມຄະແນນ ຫຼື ປ່ຽນເພັກເກັດໃໝ່ໃນການນຳໃຊ້ລະບົບ<br/>" +
              "</div>",
            showConfirmButton: false,
            timer: 20000,
          });
          return;
        }
      }

      /**
       * Check live product is not delete from warehouse
       */
      getPostShopStockForValidate({
        variables: {
          where: {
            post: selectedLive?.id,
          },
        },
      });
    }
  }, [shopValidatedData]);

  useEffect(() => {
    if (postShopStockDataForValidate) {
      /**
       * Check if live has no liveproduct will not allow to start live
       */
      let _postStockList = postShopStockDataForValidate?.postStocks?.data;

      if (_postStockList?.length == 0) {
        Swal.fire({
          icon: "error",
          title: "ບໍ່ມີສິນຄ້າທີ່ຈະຂາຍໃນໄລຟ",
          html:
            `<div className="text-left">STEP1: ເພີ່ມສິນຄ້າທີ່ຈະຂາຍໃນໄລຟນີ້ກ່ອນ<br/>` +
            "STEP2 : ເລີ່ມໄລຟຂາຍເຄື່ອງໄດ້ເລີຍ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      /**
       * Check if stock does not exist in warehouse
       */
      let checkStockExistError = false;
      _postStockList.map(async (lProduct) => {
        // console.log({ lProduct })
        if (lProduct?.stock?.isDeleted) {
          checkStockExistError = true;
        }
      });
      if (checkStockExistError) {
        Swal.fire({
          icon: "error",
          title: "ມີສິນຄ້າທີ່ຖືກລຶບອອກຈາກສະຕ໊ອກແລ້ວໃນໄລຟນີ້",
          html:
            `<div className="text-left">STEP1: ແກ້ໄຂໄລຟນີ້ ຫຼື ສ້າງໄລຟໃຫມ່<br/>` +
            "STEP2 : ລຶບສິນຄ້ານັ້ນອອກ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      /**
       * Check if User is not login with facebook
       */
      if (!fbUserAccessToken) {
        Swal.fire({
          icon: "error",
          title: "ກະລຸນາເຊື່ອມຕໍ່ກັບ Facebook ກ່ອນ!",
          html:
            `<div className="text-left">STEP1: ກົດປຸ່ມ ເຊື່ອມFacebook ຢູ່ມຸມຂວາເທິງຂອງຫນ້ານີ້ <br/>` +
            "STEP2 : ປ້ອນຂໍ້ມູນບັນຊີຂອງເຟສບຸກຂອງທ່ານ <br/>" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }

      /**
       * Check if no page selected
       */
      if (!selectedLive?.page) {
        Swal.fire({
          icon: "error",
          title: "ເລືອກເພຈທີ່ທ່ານຕ້ອງການໄລຟສົດ",
          html:
            `<div className="text-left">STEP1: ເລືອກເພຈທີ່ຕ້ອງການໄລຟໃສ່ກັບຂໍ້ມູນທີ່ສ້າງມາ <br/>` +
            "" +
            "</div>",
          showConfirmButton: false,
          timer: 20000,
        });
        setIsLoading(false);
        return;
      }
      let _pageIndex = _.findIndex(assignedPageList, { id: selectedLive.page });

      setTimeout(() => {
        try {
          /**
           * Check if facebook page has live video
           */
          if (assignedPageList[_pageIndex].isPrivate) {
            window.FB.api(
              `/${assignedPageList[_pageIndex].id}/live_videos?fields=title,id,live_status,status&access_token=${assignedPageList[_pageIndex].access_token}`,
              ({ data }) => {
                let isLiveAvailable = false;
                if (data) {
                  data.map((vdo) => {
                    if (vdo.status == "LIVE") isLiveAvailable = true;
                  });
                }
                setIsLoading(false);
                if (isLiveAvailable)
                  history.push(`/live-screen/${selectedLive?.id}`, {
                    live: selectedLive,
                    page: assignedPageList[_pageIndex],
                    isContinue,
                  });
                else {
                  setIsLoading(false);
                  Swal.fire({
                    icon: "error",
                    title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                    html:
                      `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                      "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                      "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                    showConfirmButton: false,
                    timer: 20000,
                  });
                }
              }
            );
          } else {
            window.FB.api(
              `/${assignedPageList[_pageIndex].id}/videos?fields=title,id,status,live_status&access_token=${assignedPageList[_pageIndex].access_token}`,
              ({ data }) => {
                let isLiveAvailable = false;
                data.map((vdo) => {
                  if (vdo.live_status == "LIVE") isLiveAvailable = true;
                });
                setIsLoading(false);
                if (isLiveAvailable)
                  history.push(`/live-screen/${selectedLive?.id}`, {
                    live: selectedLive,
                    page: assignedPageList[_pageIndex],
                    isContinue,
                  });
                else {
                  setIsLoading(false);
                  Swal.fire({
                    icon: "error",
                    title: "ບໍ່ມີໄລຟສົດໃນເພຈເທື່ອ!",
                    html:
                      `<div className="text-left">STEP1: ໄປທີ່ page (${assignedPageList[_pageIndex].name}) <br/> ` +
                      "STEP2 : ເລີ່ມໄລຟວິດີໂອແລ້ວລໍຖ້າຈົນກວ່າການກະກຽມນັ້ນສໍາເລັດ<br/>" +
                      "STEP3 : ກັບຄືນມາຫນ້ານີ້ແລ້ວກົດ ເລີ່ມໄລຟ ໄດ້ເລີຍ</div>",
                    showConfirmButton: false,
                    timer: 20000,
                  });
                }
              }
            );
          }
        } catch (err) {
          setIsLoading(false);
          return;
        }
      }, 2000);
    }
  }, [postShopStockDataForValidate]);

 // fetch data setting by shop
 useEffect(() => {

  if (settingData) {
    if (settingData?.settingByShopId?.orderPoint <= 1 && settingData?.settingByShopId?.isLimitedOrder) {
      setIsModalLess(true)
    }
  }
}, [settingData]);
  useEffect(() => {
    if (postsData) {
      setIsLoading(false);
      setLoading(false);
      setLiveList(postsData?.posts?.data);
      setLiveTotal(postsData?.posts?.total);
      setPageCountNumber(parseInt(postsData?.posts?.total / LIMIT_PAGE) + 1);
    }
  }, [postsData]);

  useEffect(() => {
    onNextOrBackPage();
  }, [pageNumber]);

  useEffect(() => {
    getPost();
    getFacebookLoginStatus();
    window.onpopstate = () => {
      getPost();
    };
  }, []);

  // const handleDeletePost = async () => {
  //   await triggerHideDeletePostConfirm();

  //   triggerShowDeletePostSuccess();
  //   setTimeout(() => {
  //     triggerHideDeletePostSuccess();
  //     //navigate("/post-manage");
  //   }, 1500);
  // };

  const getPost = async () => {
    try {
      setLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");
      await getPostData({
        variables: {
          where: {
            shop: SHOP_ID,
            isDeleted: false,
          },
          limit: LIMIT_PAGE,
          skip: LIMIT_PAGE * (pageNumber - 1),
          orderBy: "createdAt_DESC",
        },
      });
      setLoading(false);
      setIsLoading(false);
    } catch (error) {
      setLoading(false);
      setIsLoading(false);
      console.log("Error retrieving posts", error);
    }
  };

  const onNextOrBackPage = async () => {
    try {
      setIsLoading(true);
      let SHOP_ID = await localStorage.getItem("SHOP");

      let _where = {
        shop: SHOP_ID,
        isDeleted: false,
      };

      //check if status is selected
      if (currentStatus != "ALL") {
        _where = {
          ..._where,
          status: currentStatus,
        };
      }

      await getPostData({
        variables: {
          where: _where,
          limit: LIMIT_PAGE,
          skip: LIMIT_PAGE * (pageNumber - 1),
          orderBy: "createdAt_DESC",
        },
      });
    } catch (error) {
      console.log("error: ", error);
    }
  };

  // const _selectListLiveWithStatus = async (value) => {
  //   try {
  //     // setLoading(true)
  //     const SHOP_ID = await localStorage.getItem("SHOP");
  //     if (!value) {
  //       await getPostData({
  //         variables: {
  //           where: {
  //             shop: SHOP_ID,
  //             isDeleted: false,
  //           },
  //           orderBy: "createdAt_DESC",
  //         },
  //       });
  //     } else {
  //       await getPostData({
  //         variables: {
  //           where: {
  //             shop: SHOP_ID,
  //             description: value ?? "",
  //             isDeleted: false,
  //           },
  //           orderBy: "createdAt_DESC",
  //         },
  //       });
  //     }
  //     // setLoading(false)
  //   } catch (error) {
  //     setLoading(false);
  //     console.log("error: ", error);
  //   }
  // };

  // const onSelectedStatus = async (e) => {
  //   try {
  //     const filterValue = e.target.value;
  //     const SHOP_ID = await localStorage.getItem("SHOP");
  //     setCurrentStatus(filterValue);
  //     setPageNumber(1);
  //     if (filterValue != "ALL") {
  //       await getPostData({
  //         variables: {
  //           where: {
  //             shop: SHOP_ID,
  //             isDeleted: false,
  //             status: filterValue,
  //           },
  //           orderBy: "createdAt_DESC",
  //         },
  //       });
  //     } else {
  //       await getPostData({
  //         variables: {
  //           where: {
  //             shop: SHOP_ID,
  //             isDeleted: false,
  //           },
  //           orderBy: "createdAt_DESC",
  //         },
  //       });
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     console.log("Error retrieving posts", error);
  //   }
  // };

  const getFacebookLoginStatus = () => {
    try {
      window.FB.getLoginStatus((response) => {
        if (response.authResponse)
          setFbUserAccessToken(response.authResponse.accessToken);
      });
    } catch (error) {
      console.log("Error FACEBOOK STATUS", error);
    }
  };

  const _changeSeletedPage = async (e, index) => {
    let _selectPageFilter = _.filter(assignedPageList, { id: e.target.value });
    let _liveList = [...liveList];
    _liveList[index] = { ..._liveList[index], page: _selectPageFilter[0].id };
    setLiveList(_liveList);

    await updatePost({
      variables: {
        where: {
          id: liveList[index]?.id,
        },
        data: {
          page: _selectPageFilter[0].id,
          pageName: _selectPageFilter[0].name,
        },
      },
    });
  };

  const _goLiveDetail = (live) => {
    history.push(`/post-detail`, { live });
  };

  const checkLivePage = (_live) => {
    let isMatched = false;
    assignedPageList.map((page, pIndex) => {
      if (page?.id == _live.page) isMatched = true;
    });
    return isMatched;
  };

  // const getLivePage = (_live) => {
  //   let isMatched;
  //   assignedPageList.map((page, pIndex) => {
  //     if (page?.id == _live.page) isMatched = page;
  //   });
  //   return isMatched;
  // };

  const getLivePage = (live) => {
    if (assignedPageList?.length <= 0) return null;
    return assignedPageList.find(page => page.id === live.page);
  };

  // const _updateStockWhenDeletePost = async (lStock) => {
  //   await updateStock({
  //     variables: {
  //       where: {
  //         id: lStock?.stock?.id,
  //       },
  //       data: {
  //         amount: lStock?.stock?.amount + lStock?.amount,
  //         isUsing: false
  //       },
  //     },
  //   });
  // };

  const _deletePost = async () => {
    if (deleteData) {
      try {
        if (isLoading) return;
        setIsLoading(true);

        // const _postStocks = await getPostStocks({
        //   variables: {
        //     where: {
        //       fbFeedId: deleteData?.fbFeedId,
        //       isDeleted: false
        //     },
        //     limit: 1000,
        //     skip: 0,
        //     orderBy: "createdAt_DESC"
        //   }
        // });

        // console.log('_postStocks: ', _postStocks.data.postStocks.data)

        // await _postStocks?.data?.postStocks?.data.map(async (stock) => {
        //   await _updateStockWhenDeletePost(stock)
        // })

        /***************************
         * Delete live record
         **************************/
        await deletePost({
          variables: {
            where: {
              id: deleteData?.id,
            },
          },
        });
        setLoading(false);
        setIsLoading(false);
        const _filterPosts = liveList.filter(
          (post) => post.id != deleteData.id
        );
        setLiveList(_filterPosts);

        setShowDeleteModal(false);
        triggerHideDeletePostConfirm();
        addToast("ລຶບໂພສສໍາເລັດ", {
          appearance: "success",
          autoDismiss: true,
        });
        setDeleteData();
      } catch (err) {
        console.log(err);
        setShowDeleteModal(false);
        setIsLoading(false);
        addToast("ມີບາງຢ່າງຜິດພາດ ໃນການລຶບໂພສ", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  };

  const onNextPage = () => {
    setPageNumber(
      parseInt(pageNumber) != parseInt(pageCountNumber)
        ? parseInt(pageNumber) + 1
        : parseInt(pageCountNumber)
    );
  };

  const onBackPage = () => {
    setPageNumber(parseInt(pageNumber) != 1 ? parseInt(pageNumber) - 1 : 1);
  };

  const onChoosePage = (page) => {
    setPageNumber(parseInt(page));
  };

  const onStartHook = async (live) => {
    try {
      setIsLoading(true);
      const _getPage = getLivePage(live);
      if (!_getPage?.access_token || !_getPage) {
        setIsLoading(false);
        return addToast("ກະລຸນາເຊື່ອມ Facebook ກ່ອນ!", {
          appearance: "warning",
          autoDismiss: true,
        });
      }

      await startHookPost({
        variables: {
          where: {
            id: live.id,
            pageId: live.page,
            access_token: _getPage?.access_token,
          },
        },
      });
      await getPost();
      setIsLoading(false);
      addToast("ເປີດໂພສສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("error: ", error);
      addToast("ເປີດໂພສບໍ່ສໍາເລັດ. ກະລຸນາເຊື່ອມເຟສໃໝ່ແລ້ວລອງໃໝ່ອີກຄັ້ງ", {
        appearance: "warning",
        autoDismiss: true,
      });
      setIsLoading(false);
    }
  };

  const onStopHook = async (live) => {
    try {
      setIsLoading(true);
      await stopHookPost({
        variables: {
          where: {
            id: live.id,
          },
        },
      });
      await getPost();
      setIsLoading(false);
      addToast("ປິດໂພສສໍາເລັດ", {
        appearance: "success",
        autoDismiss: true,
      });
    } catch (error) {
      console.log("error: ", error);
      setIsLoading(false);
    }
  };


  //modal
  const triggerHideDeletePostConfirm = () => setShowDeletePostConfirm(false);
  const triggerShowDeletePostConfirm = () => setShowDeletePostConfirm(true);

  const handleCloseModalLess = () => {
    history.push(`/dashboard`)
    setIsModalLess(false)
  }

  // if (isLoading) return <AnimationLoading />;
  if (isLoading) return <LoadingSpinner />

  return (
    <div>
      {/* {isLoading && <AnimationLoading />} */}
      {/* <SuccessModal show={showDeletePostSuccess} onHide={triggerHideDeletePostSuccess} title="ລຶບສຳເລັດ"/> */}
      {width > 700 ? (
        <div>
          <BasicModal
            show={showDeletePostConfirm}
            Illustration={"images/Illustration.png"}
            okay={_deletePost}
            onHide={triggerHideDeletePostConfirm}
            title="ທ່ານຕ້ອງການລຶບຂໍ້ມູນ ຫຼື ບໍ່?"
            leftButtonName="ຍົກເລີກ"
            rightButtonName="ຕົກລົງ"
          />
          <div className="Contain">
            <div className="live-list">
              <div className="baner">
                <img
                  src={Group}
                  alt=""
                  style={{
                    width: "32px",
                    height: "32px",
                    marginRight: "10px",
                  }}
                />
                <span style={{ fontSize: "22px" }}>ຈັດການໜ້າຟີດ</span>
              </div>
              <p>
                ສະແດງໂພສທີ່ເຊື່ອມຕໍ່ການດູດອໍເດີ້
                ສ້າງໂພສເພື່ອທີ່ຈະເຊື່ອມຕໍ່ກັບການດູດອໍເດີ້ ແລະ
                ເບິ່ງຂໍ້ມູນໂພສພ້ອມສະຫຼຸບລາຍການສັ່ງຊື້ໃນໂພສນັ້ນໆແບບລາຍການ ແລະ
                ສະຖິຕິ
              </p>

              <div className="d-flex gap-4">
                <button
                  type="button"
                  style={{
                    border: "none",
                    background: COLOR_APP,
                    color: '#fff',
                    padding: '.5em 1.5em',
                    borderRadius: '.3em'
                  }}
                  onClick={() =>
                    history.push(`/post-feed-add`, { editMode: false })
                  }>
                  <FontAwesomeIcon
                    icon={faPlus}
                    style={{
                      color: "#FFFFFF",
                      fontSize: "16px",
                      paddingRight: "5px",
                    }}
                  />
                  ສ້າງໂພສໃໝ່
                </button>

              </div>
            </div>

            <div style={{ marginRight: "72px" }}>
              <Lottie
                animationData={shoppingAnimation}
                loop={true}
                style={{
                  width: "247px",
                  height: "169px",
                }}
              />
            </div>
          </div>

          <div className="tab-live-manu">
            <span
              style={{
                fontSize: "18px",
                fontWeight: "bold",
                color: "#252A31;",
              }}>
              ລາຍການໂພສ
            </span>
            <div>
              {liveList.length <= 0 ? (
                <div className="no_data">
                  <img src={"/images/no_data.png"} alt="no_data" />
                  <h1>ບໍ່ມີຂໍ້ມູນ</h1>
                </div>
              ) : (
                <Table
                  style={{
                    marginTop: "20px",
                    borderCollapse: "collapse",
                    width: "100% ",
                  }}>
                  <tbody>
                    <tr>
                      <th>ປິດ/ເປີດ</th>
                      <th>ຫົວຂໍ້</th>
                      <th>ເພຈເຊື່ອມຕໍ່</th>
                      <th>ສະຖານະ</th>
                      <th>ວັນເວລາ</th>
                      {/* <th >ອໍເດີ້ໃນໂພສ</th> */}
                      <th>ຈັດການ</th>
                    </tr>
                  </tbody>
                  <tbody>
                    {liveList &&
                      liveList.length > 0 &&
                      liveList?.map((live, index) => (
                        <tr
                          id="trActionCell"
                          key={index}
                          onClick={() => {
                            setDeleteData(live);
                          }}>
                          <td
                            style={{
                              verticalAlign: "middle",
                              width: "100px",
                            }}>
                            <div>
                              {live.status == "CREATED" && (
                                <Switch
                                  onChange={() => onStartHook(live)}
                                  checked={false}
                                  onColor="#bfbdc7"
                                  onHandleColor="#422f90"
                                  handleDiameter={20}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                  height={20}
                                  width={38}
                                  className="react-switch"
                                  id="material-switch"
                                />
                              )}
                              {live.status == "ONAIR" && (
                                <Switch
                                  onChange={() => onStopHook(live)}
                                  checked={true}
                                  onColor="#bfbdc7"
                                  onHandleColor="#422f90"
                                  handleDiameter={20}
                                  uncheckedIcon={false}
                                  checkedIcon={false}
                                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                                  height={20}
                                  width={38}
                                  className="react-switch"
                                  id="material-switch"
                                />
                              )}
                            </div>
                          </td>

                          <td
                            style={{
                              verticalAlign: "middle",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 250,
                              fontSize: "16px",
                            }}>
                            <span style={{ fontSize: "16px" }}>
                              {live?.description || "ຍັງບໍ່ກໍານົດ"}
                            </span>
                          </td>
                          <td
                            style={{
                              verticalAlign: "middle",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 250,
                              width: "200px",
                            }}>
                            <p>{live?.pageName}</p>
                            {/* {
                            live.status == "COMPLETED" ? (
                              <p>{live?.pageName}</p>
                            ) : assignedPageList?.length > 0 ? (
                              <Form.Control
                                as="select"
                                value={checkLivePage(live) ? live.page : ""}
                                onChange={(e) => _changeSeletedPage(e, index)}
                                disabled
                              >
                                <option disabled={true} value="">
                                  ເລືອກເພຈເຊື່ອມຕໍ່
                                </option>
                                {assignedPageList?.map((page, pIndex) => {
                                  return (
                                    <option
                                      value={page?.id}
                                      disabled
                                      key={"page" + pIndex}
                                    >
                                      {page?.name}
                                    </option>
                                  );
                                })}
                              </Form.Control>
                            ) : (
                              <p>ກະລຸນາເຊື່ອມຕໍ່ Facebook ກ່ອນ</p>
                            )
                            // <button className="btn btn-primary" onClick={connectFacebook}>ເຊື່ອມ Facebook</button>
                          } */}
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            {live?.status === CREATED ? (
                              <div
                                style={{
                                  border: "1px solid #D1D1D1 ",
                                  borderRadius: "6px",
                                  color: "#D1D1D1",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  height: 28,
                                  alignItems: "center",
                                  padding: "2px 5px",
                                }}>
                                ປິດໃຊ້ງານ
                              </div>
                            ) : (
                              <div
                                style={{
                                  border: "1px solid #7FC008 ",
                                  borderRadius: "6px",
                                  color: "#7FC008",
                                  textAlign: "center",
                                  whiteSpace: "nowrap",
                                  height: 28,
                                  padding: "2px 5px",
                                  alignItems: "center",
                                }}>
                                ໃຊ້ງານຢູ່
                              </div>
                            )}
                          </td>
                          <td>
                            {moment(live?.createdAt).format("DD/MM/YYYY HH:mm")}
                          </td>
                          <td style={{ verticalAlign: "middle" }}>
                            <div style={{ display: "flex" }}>
                              {" "}
                              <button
                                style={{
                                  background: "#F7F7F7",
                                  color: "#422F90",
                                  border: "1px solid #422F90 ",
                                  borderRadius: "6px",
                                  verticalAlign: "middle",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "8px 16px",
                                  minWidth: "110px",
                                  display: "flex",
                                  justifyItems: "baseline",
                                  whiteSpace: "nowrap",
                                }}
                                onClick={() => _goLiveDetail(live)}>
                                <FontAwesomeIcon
                                  icon={faEye}
                                  style={{ marginRight: 5 }}
                                />{" "}
                                ລາຍລະອຽດ
                              </button>
                              {live?.status === CREATED ? (
                                <div style={{ display: "flex" }}>
                                  <button
                                    className="btn-icon hiddenActionCell"
                                    style={{
                                      background: "#F7F7F7",
                                      borderRadius: "6px",
                                      color: "#19C332",
                                      width: "36px",
                                      height: "36px",
                                    }}
                                    onClick={() => {
                                      history.push(`/post-feed-add`, {
                                        editMode: true,
                                        data: live,
                                      });
                                    }}>
                                    <FontAwesomeIcon icon={faPen} />
                                  </button>

                                  <button
                                    onClick={triggerShowDeletePostConfirm}
                                    a
                                    className="btn-icon hiddenActionCell"
                                    style={{
                                      background: "#F7F7F7",
                                      borderRadius: "6px",
                                      borderColor: "#F7F7F7",
                                      color: "#D21C1C",
                                      width: "36px",
                                      height: "36px",
                                    }}>
                                    <FontAwesomeIcon icon={faTrash} />
                                  </button>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              )}
            </div>

            {pageCountNumber && liveList.length > 0 && (
              <div
                className="text-center"
                style={{ display: "flex", justifyContent: "center" }}>
                <nav aria-label="Page navigation example">
                  <ul className="pagination">
                    <li
                      className="page-item"
                      onClick={() => onBackPage()}
                      style={{ cursor: "pointer" }}>
                      <a className="page-link">ກັບຄືນ</a>
                    </li>
                    {Array.from(Array(pageCountNumber), (e, i) => (
                      <li
                        className={`page-item ${pageNumber == i + 1 ? "active" : ""
                          }`}
                        key={i}
                        style={{ cursor: "pointer" }}
                        onClick={() => onChoosePage(i + 1)}>
                        <a className="page-link">{i + 1}</a>
                      </li>
                    ))}
                    <li
                      className="page-item"
                      onClick={() => onNextPage()}
                      style={{ cursor: "pointer" }}>
                      <a className="page-link">ຕໍ່ໄປ</a>
                    </li>
                  </ul>
                </nav>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div style={{ margin: "60px 10px 10px 10px" }}>
          {isLoading && <AnimationLoading />}
          <div>
            <div
              style={{
                marginBottom: 20,
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  color: COLOR_APP,
                }}>
                <FontAwesomeIcon icon={faDatabase} />
                <div className="ml-2">ຈັດການຫນ້າຟິດ</div>
              </div>
              <Button
                style={{
                  border: "none",
                  background: COLOR_APP,
                  color: "#fff",
                  fontSize: 12,
                  borderRadius: 6,
                  marginRight: 5,
                }}
                onClick={() =>
                  history.push(`/post-feed-add`, { editMode: false })
                }>
                <FontAwesomeIcon
                  icon={faPlus}
                  style={{
                    color: "#FFFFFF",
                    fontSize: "16px",
                    paddingRight: "5px",
                  }}
                />
                ສ້າງໂພສໃໝ່
              </Button>
            </div>
            <div>
              ສະແດງໂພສທີ່ເຊື່ອມຕໍ່ການດູດອໍເດີ້
              ສ້າງໂພສເພື່ອທີ່ຈະເຊື່ອມຕໍ່ກັບການດູດອໍເດີ້ ແລະ
              ເບິ່ງຂໍ້ມູນໂພສພ້ອມສະຫຼຸບລາຍການສັ່ງຊື້ໃນໂພສນັ້ນໆແບບລາຍການ ແລະ
              ສະຖິຕິ
            </div>
          </div>
          <div style={{ margin: "0px 10px" }}>
            <div className="mt-2" style={{ fontWeight: "bold" }}>
              ລາຍການໂພສ
            </div>
            {liveList.length <= 0 ? (
              <div className="no_data">
                <img src={"/images/no_data.png"} alt="no_data" />
                <h1>ບໍ່ມີຂໍ້ມູນ</h1>
              </div>
            ) : (
              <Table
                responsive
                style={{
                  marginTop: "5px",
                  borderCollapse: "collapse",
                  width: "100% ",
                }}>
                <thead>
                  <tr style={{ whiteSpace: "nowrap" }}>
                    <th style={{ borderBottom: "none" }}>ປິດ/ເປີດ</th>
                    <th style={{ borderBottom: "none" }}>ຫົວຂໍ້ໂພສ</th>
                    <th style={{ borderBottom: "none" }}>ເພຈ</th>
                    <th style={{ borderBottom: "none" }}>ເວລາ</th>
                    <th style={{ borderBottom: "none" }}>ຈັດການ</th>
                  </tr>
                  {liveList.length > 0 &&
                    liveList.map((live, index) => (
                      <tr
                        key={index}
                        onClick={() => {
                          setDeleteData(live);
                        }}>
                        <td>
                          {live.status == "CREATED" && (
                            <Switch
                              onChange={() => onStartHook(live)}
                              checked={false}
                              onColor="#bfbdc7"
                              onHandleColor="#422f90"
                              handleDiameter={20}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={38}
                              className="react-switch"
                              id="material-switch"
                            />
                          )}
                          {live.status == "ONAIR" && (
                            <Switch
                              onChange={() => onStopHook(live)}
                              checked={true}
                              onColor="#bfbdc7"
                              onHandleColor="#422f90"
                              handleDiameter={20}
                              uncheckedIcon={false}
                              checkedIcon={false}
                              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                              height={20}
                              width={38}
                              className="react-switch"
                              id="material-switch"
                            />
                          )}
                        </td>
                        <td>
                          {" "}
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 200,
                            }}>
                            {live?.description ?? "ຍັງບໍ່ກໍານົດ"}
                          </div>
                        </td>
                        <td>
                          <div
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              maxWidth: 200,
                            }}>
                            {live?.pageName ?? ""}
                          </div>
                          {/* <div className="menu-nav">
                           <div className="dropdownThreeDots-container" tabindex="-1">
                             <div className="three-dots" onClick={() => {
                               setSelectedLive(live);
                               setShowOptionModal(true);
                             }}></div>
                           </div>
                         </div> */}
                        </td>
                        <td>
                          {moment(live?.createdAt).format("DD/MM/YYYY HH:mm")}
                        </td>
                        <td style={{ whiteSpace: "nowrap" }}>
                          <div
                            className="row-btn"
                            style={{
                              display: "flex",
                              alignItems: "center",
                            }}>
                            <button
                              style={{
                                background: "#F7F7F7",
                                color: "#422F90",
                                border: "1px solid #422F90 ",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                marginRight: "5px",
                                padding: "4px 4px",
                                fontSize: 12,
                              }}
                              onClick={() => _goLiveDetail(live)}>
                              <FontAwesomeIcon
                                icon={faEye}
                                style={{ marginRight: 5 }}
                              />{" "}
                              ລາຍລະອຽດ
                            </button>
                            {live?.status === CREATED && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}>
                                <Button
                                  onClick={() => {
                                    history.push(`/post-feed-add`, {
                                      editMode: true,
                                      data: live,
                                    });
                                  }}
                                  style={{
                                    background: "#F7F7F7",
                                    borderRadius: "6px",
                                    color: "#19C332",
                                    width: "30px",
                                    height: "30px",
                                    margin: "0px 10px",
                                    border: "none",
                                  }}>
                                  <FontAwesomeIcon icon={faPen} />
                                </Button>
                                <Button
                                  onClick={triggerShowDeletePostConfirm}
                                  // className="btn-icon hiddenActionCell"
                                  style={{
                                    background: "#F7F7F7",
                                    borderRadius: "6px",
                                    borderColor: "#F7F7F7",
                                    color: "#D21C1C",
                                    width: "30px",
                                    height: "30px",
                                  }}>
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button>
                              </div>
                            )}
                          </div>
                          {/* <button
                           style={{
                             background: "#F7F7F7",
                             color: "#422F90",
                             border: "1px solid #422F90 ",
                             borderRadius: "6px",
                             display: 'flex',
                             alignItems: "center",
                             marginRight: '5px',
                             padding: "4px 4px",
                             fontSize: 12
                           }}
                           onClick={() => _goLiveDetail(selectedLive)}
                         >
                           <FontAwesomeIcon
                             icon={faEye}
                             style={{ marginRight: 5 }}
                           />{" "}
                           ລາຍລະອຽດ
                         </button>
                         {
                           live?.status === CREATED && <div style={{ display: 'flex', justifyContent: 'center' }}>
                             <button
                               style={{
                                 background: 'green',
                                 color: "#FFF",
                                 border: "1px solid #eee ",
                                 borderRadius: "6px",
                                 marginRight: '5px',
                                 display: 'flex',
                                 alignItems: "center",
                                 padding: "8px 4px",
                               }}
                               onClick={() => {
                                 history.push(`/post-feed-add`, {
                                   editMode: true,
                                   data: selectedLive,
                                 });
                               }}
                             >
                               <FontAwesomeIcon
                                 icon={faPen}
                               />{" "}
                             </button>
                             <button
                               className="btn btn-outline-danger"
                               onClick={triggerShowDeletePostConfirm}
                             >
                               <FontAwesomeIcon
                                 icon={faTrash}
                               />{" "}
                             </button>
                           </div>
                         } */}
                        </td>
                      </tr>
                    ))}
                </thead>
              </Table>
            )}
            {/* <div style={{ background: '#c0c0c0', padding: '5px 0px' }} className='row'>
                <div className="col-3">ປິດ/ເປີດ</div>
                <div className="col-4">ຫົວຂໍ້ໂພສ</div>
                <div className="col-5">ເພຈ</div>
              </div>
              {
                liveList.length > 0 && liveList.map((live, index) => <div key={index} style={{ background: '#fff', boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)', borderRadius: 2, alignItems: 'center', marginTop: '5px', padding: '10px 0px' }} className='row'>
                  <div className="col-3">{live.status == "CREATED" && (
                    <Switch
                      onChange={() => onStartHook(live)}
                      checked={false}
                      onColor="#bfbdc7"
                      onHandleColor="#422f90"
                      handleDiameter={20}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={20}
                      width={38}
                      className="react-switch"
                      id="material-switch"
                    />
                  )}
                    {live.status == "ONAIR" && (
                      <Switch
                        onChange={() => onStopHook(live)}
                        checked={true}
                        onColor="#bfbdc7"
                        onHandleColor="#422f90"
                        handleDiameter={20}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                        activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                        height={20}
                        width={38}
                        className="react-switch"
                        id="material-switch"
                      />
                    )}</div>
                  <div className="col-4" style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: 'nowrap', maxLines: '2' }}>{live?.description ?? 'ຍັງບໍ່ກໍານົດ'}</div>
                  <div className="col-5" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div>{live?.pageName ?? ''}</div>
                    <div className="menu-nav">
                      <div className="dropdownThreeDots-container" tabindex="-1">
                        <div className="three-dots" onClick={() => {
                          setSelectedLive(live);
                          setShowOptionModal(true);
                        }}></div>
                      </div>
                    </div>
                  </div>
                </div>)
              } */}
          </div>
          {/* <Modal size="sm" show={showOptionModal} onHide={() => setShowOptionModal(false)} centered>
              <Modal.Body style={{ display: 'flex', justifyContent: 'center' }}>
                <button
                  style={{
                    background: "#F7F7F7",
                    color: "#422F90",
                    border: "1px solid #422F90 ",
                    borderRadius: "6px",
                    display: 'flex',
                    alignItems: "center",
                    marginRight: '5px',
                    padding: "8px 4px",
                  }}
                  onClick={() => _goLiveDetail(selectedLive)}
                >
                  <FontAwesomeIcon
                    icon={faEye}
                    style={{ marginRight: 5 }}
                  />{" "}
                  ລາຍລະອຽດ
                </button>
                {
                  selectedLive?.status === CREATED && <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <button
                      style={{
                        background: COLOR_APP,
                        color: "#FFF",
                        border: "1px solid #422F90 ",
                        borderRadius: "6px",
                        marginRight: '5px',
                        display: 'flex',
                        alignItems: "center",
                        padding: "8px 4px",
                      }}
                      onClick={() => {
                        history.push(`/post-feed-add`, {
                          editMode: true,
                          data: selectedLive,
                        });
                      }}
                    >
                      <FontAwesomeIcon
                        icon={faPen}
                        style={{ marginRight: 5 }}
                      />{" "}
                      ແກ້ໄຂ
                    </button>
                    <button
                      className="btn btn-outline-danger"
                      onClick={triggerShowDeletePostConfirm}
                    >
                      <FontAwesomeIcon
                        icon={faTrash}
                        style={{ marginRight: 5 }}
                      />{" "}
                      ລຶບ
                    </button>
                  </div>
                }

              </Modal.Body>
            </Modal> */}
          <Modal
            size="sm"
            show={showDeletePostConfirm}
            onHide={triggerHideDeletePostConfirm}
            centered>
            <Modal.Header closeButton>
              <Modal.Title>ທ່ານຕ້ອງການລຶບຂໍ້ມູນແທ້ບໍ?</Modal.Title>
            </Modal.Header>
            <Modal.Body></Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={triggerHideDeletePostConfirm}>
                ຍົກເລີກ
              </Button>
              <Button variant="primary" onClick={_deletePost}>
                ຕົກລອງ
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      )}

      <PackageNotPermission isModalLess={isModalLess} handleCloseModalLess={handleCloseModalLess} title="ຟັງຊັ່ນ Post" />

    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    fbdata: state.fbdata,
  };
};

export default connect(mapStateToProps)(PostFeed);
